import { createFileRoute } from '@tanstack/react-router'

import { HodInboxPage } from '@/systems/issues/features/hod-inbox/components/HodInboxPage'
import { hodInboxQueryOptions } from '@/systems/issues/features/hod-inbox/hooks/useHodInbox'

// HOD's main work surface — 4-bucket inbox. Prefetches the default
// (open) bucket so the page renders with badges + first list ready.
export const Route = createFileRoute('/hod/issues')({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(hodInboxQueryOptions({ bucket: 'open' }))
  },
  component: HodInboxPage,
})
